
function openModal(modalID) {
  var modal = document.getElementById(modalID);
  modal.classList.add('open');
}

function closeModal(modalID) {
  var modal = document.getElementById(modalID);
  modal.classList.remove('open');
}

jQuery(document).ready(function() {

  var modalTriggers = document.querySelectorAll('.modal-trigger');
  var modalOverlays = document.querySelectorAll('.modal-overlay');
  var modalCloseBtns = document.querySelectorAll('.modal-close');


  modalTriggers.forEach(function(trigger) {
    trigger.addEventListener('click', function(e) {
      e.preventDefault();
      var modalID = this.dataset.modalid;
      openModal(modalID);
    });
  });

  modalCloseBtns.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var modalID = this.closest('.modal').id;
      closeModal(modalID);
    });
  });

  modalOverlays.forEach(function(overlay) {
    overlay.addEventListener('click', function() {
      var modalID = this.closest('.modal').id;
      closeModal(modalID);
    });
  });


});
